export default __webpack_public_path__ + "static/media/Milk2Icecream_07.5cf47923.png";